module.exports = __webpack_public_path__ + "static/DomApothekeBeratung-c7db5a33fd275082d8cf914b92d6ed86.jpg";